import React from "react";
import "./ChartBar.css";

const ChartBar = (props) => {
  let barHeight = "0%";

  if (props.maxValue > 0) {
    barHeight = Math.round((props.value / props.maxValue) * 100) + "%";
  }
  return (
    <div className="chart-bar">
      <div className="chart-bar__inner">
        <div className="chart-bar__fill" style={{ height: barHeight }}></div>
        <div className="chart-bar__label">{props.chartLabel}</div>
      </div>
    </div>
  );
};

export default ChartBar;
